import { Heart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useBookmarks } from "@/lib/bookmarks";
import { useAuth } from "@/lib/auth";

export default function SaveButton({ providerId, providerSlug, variant = "icon", className = "" }) {
  const { isSaved, toggle } = useBookmarks();
  const { user } = useAuth() || {};
  const nav = useNavigate();
  const saved = isSaved(providerId);

  const handle = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) {
      toast.error("Sign in to save providers");
      nav("/login");
      return;
    }
    const res = await toggle(providerSlug || providerId, providerId);
    if (res?.saved === true) toast.success("Saved to your list");
    else if (res?.saved === false) toast("Removed from saved");
  };

  if (variant === "full") {
    return (
      <button
        onClick={handle}
        className={`inline-flex items-center gap-1.5 px-3 py-2 rounded-full border transition ${saved ? "bg-[#064E3B] text-white border-[#064E3B]" : "bg-white border-stone-200 text-stone-700 hover:border-[#064E3B]/40"} ${className}`}
        data-testid="save-provider-btn"
        aria-label={saved ? "Remove from saved" : "Save provider"}
      >
        <Heart className={`w-4 h-4 ${saved ? "fill-current" : ""}`} />
        <span className="text-sm font-medium">{saved ? "Saved" : "Save"}</span>
      </button>
    );
  }

  return (
    <button
      onClick={handle}
      className={`w-8 h-8 rounded-full bg-white/95 hover:bg-white shadow-sm flex items-center justify-center transition ${className}`}
      data-testid="save-provider-icon"
      aria-label={saved ? "Remove from saved" : "Save provider"}
    >
      <Heart className={`w-4 h-4 transition ${saved ? "fill-[#E03131] text-[#E03131]" : "text-stone-600"}`} />
    </button>
  );
}
